export default __webpack_public_path__ + "static/media/BGAgreement.2c671879.webp";